export enum SubscriptionStatus {
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  Trialing = 'trialing',
  Active = 'active',
  PastDue = 'past_due',
  Canceled = 'canceled',
  Unpaid = 'unpaid',
  FreeTrialEnded = 'free_trial_ended',
  Paused = 'paused',
}

/** Returns whether a given subscription status is considered active or not */
export const isSubscriptionActive: (status?: SubscriptionStatus) => boolean = (status) => {
  switch (status) {
    case SubscriptionStatus.Active:
    case SubscriptionStatus.Trialing:
    case SubscriptionStatus.PastDue:
      return true;
    case SubscriptionStatus.Incomplete:
    case SubscriptionStatus.IncompleteExpired:
    case SubscriptionStatus.Canceled:
    case SubscriptionStatus.Unpaid:
    case SubscriptionStatus.FreeTrialEnded:
    case SubscriptionStatus.Paused:
    default:
      return false;
  }
};
